import React from 'react';
import styled from 'styled-components';

// Container principal da barra de progresso
const ProgressContainer = styled.div`
  display: flex;
  gap: 8px; /* Espaçamento entre os blocos */
  padding: 16px;
  border-radius: 4px;
  width: fit-content;
`;

// Bloco individual da barra
const ProgressBlock = styled.div`
  width: 36px; /* Largura de cada bloco */
  height: 10px; /* Altura de cada bloco */
  border-radius: 6px; /* Bordas arredondadas/chanfradas */
  
  /* Transição suave para quando o estado mudar */
  transition: background-color 0.3s ease; 

  /* Lógica dinâmica de cores baseada nas props */
  background-color: ${(props) => (props.$active ? '#FF5722' : '#333333')};
`;

export const SegmentedProgress = ({ 
  totalBlocks = 5, 
  currentProgress = 3 
}) => {
  return (
    <ProgressContainer>
      {Array.from({ length: totalBlocks }).map((_, index) => (
        <ProgressBlock 
          key={index} 
          $active={index < currentProgress} 
        />
      ))}
    </ProgressContainer>
  );
};

export default SegmentedProgress;